module Widgets.Form.NumberInput where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Argonaut as J
import Data.Int (floor, toNumber)
import Data.Maybe (maybe)
import Data.Number as Num
import GraphQL.Shape (QueryField(..))
import Widgets.Form.Class (class FormWidget, fieldAccessProps, formWidgetState, fieldClass, fieldId, setFromJson)
import Widgets.Form.Common (widgetLabelS')


newtype NumberInput = NumberInput NumberInputType
derive newtype instance showNumberInput :: Show NumberInput
type NumberInputType =
    { id :: String
    , label :: String
    , cls :: String
    , step :: Number
    , value :: Maybe Number
    , placeholder :: Maybe String
    }

isIntInput :: NumberInputType -> Boolean
isIntInput { step } = toNumber (floor step) == step

instance numberInputFW :: FormWidget NumberInput where
    getId (NumberInput state) = state.id
    isLeaf _ = true
    asField (NumberInput state) = Just $ QScalar state.id
    fieldPaths fc (NumberInput state) = [ fieldId fc state.id ]

    toWidget fc (NumberInput state) = formWidgetState <$> D.div
        [ P.key id, P.className $ fieldClass state ]
        [ widgetLabelS' fc state
        , D.input
            ( [ P._type "number", P._id id
            , P.className "widget-input"
            , P.placeholder $ fromMaybe "" state.placeholder
            , P.value value
            , P.step $ show state.step
            , NumberInput <$> handleInput <$> P.unsafeTargetValue <$> P.onInput
            ] <> fieldAccessProps fc state.id )
        ]
      where
        id = fieldId fc state.id
        value | isIntInput state = fromMaybe "" $ map (show <<< floor) state.value
        value = show $ fromMaybe 0.0 state.value
        handleInput newval =
            case Num.fromString newval of
                 Just num -> state { value = Just num }
                 Nothing -> state { value = Nothing }

    getData _ (NumberInput state) = maybe J.jsonNull J.fromNumber state.value

    setData _ st@(NumberInput _    ) json | json == J.fromString "" = Right st
    setData _ st@(NumberInput state) json =
        setFromJson st (\val -> Right $ NumberInput $ state { value = val }) json
